import { useOTPs } from '../../new/pages/collections/hooks';
import auth from '../../components/auth';
import { keys } from '../../new/helpers/general';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { useGetInfluencerQuery } from '../../../generated/graphql';

export const tabs = {
  subscriptions: 'Subscriptions',
  otps: 'One-Time Purchases',
  free: 'Free Offers',
};

export type TabHash = keyof typeof tabs;

type AnalyticsTabs = Array<[hash: TabHash, name: string]>;

export const useInfluencerAnalyticsTabs = (): AnalyticsTabs => {
  const influencerId = useInfluencerId();
  const otps = useOTPs(influencerId);
  const influencerQuery = useGetInfluencerQuery({
    variables: { id: influencerId },
    skip: !influencerId,
  });
  const isOtpVisible =
    (otps.type === 'fetched' && otps.value.length > 0) ||
    auth.isAdministrator();
  const isFreeVisible =
    auth.isAdministrator() ||
    influencerQuery.data?.creator?.customizations?.isFreeOfferEnabled === true;

  const tabsParsed = keys(tabs).flatMap((hash) => {
    if (hash === 'otps' && !isOtpVisible) return [];
    if (hash === 'free' && !isFreeVisible) return [];
    return [[hash, tabs[hash]]] as AnalyticsTabs;
  });

  return tabsParsed;
};
